import React from 'react';

// Ícones de categoria como SVG de traço (consistentes com o BottomNav).
// viewBox 24×24, herdam `currentColor` — o marcador/card controla a cor.
const PATHS = {
  mercado: (
    <>
      <circle cx="9" cy="20" r="1.6" />
      <circle cx="17" cy="20" r="1.6" />
      <path d="M3 4h2l2.6 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6" />
    </>
  ),
  farmacia: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="M12 8v8M8 12h8" />
    </>
  ),
  padaria: (
    <path d="M4 16c-1.1 0-2-.9-2-2 0-3.3 2.2-5.5 5-5.5h.3C7.8 6.9 9 6 10.7 6 13.2 6 15 7.8 15 10.3c0 .5-.1 1-.2 1.5h.2c2.1 0 4 1.7 4 3.7 0 1.4-1.1 2.5-2.5 2.5H4z" />
  ),
  restaurante: (
    <>
      <path d="M7 2v20" />
      <path d="M7 2C5.5 2 4.5 3.5 4.5 5.5V9c0 1 .9 2 2 2" />
      <path d="M7 2c1.5 0 2.5 1.5 2.5 3.5V9c0 1-.9 2-2 2" />
      <path d="M17 11v11" />
      <path d="M17 2c3 0 5 1.8 5 4.5S20 11 17 11" />
    </>
  ),
  servicos: (
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  ),
  evento: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </>
  ),
  publico: (
    <>
      <path d="M3 21h18" />
      <path d="M5 21V10l7-5 7 5v11" />
      <path d="M9 21v-4h6v4" />
      <path d="M9 9h.01M15 9h.01" />
    </>
  ),
  mercado_publico: (
    <>
      <path d="M3 9l1.2-5h15.6L21 9" />
      <path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" />
      <path d="M5 12v9h14v-9" />
      <path d="M9 21v-5h6v5" />
    </>
  ),
  default: (
    <>
      <path d="M3 9l1.2-5h15.6L21 9" />
      <path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" />
      <path d="M5 12v9h14v-9" />
      <path d="M9 21v-5h6v5" />
    </>
  ),
};

export function CategoryIcon({ category = 'default', size = 18, className, strokeWidth = 1.8 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {PATHS[category] || PATHS.default}
    </svg>
  );
}
